import { render, staticRenderFns } from "./AgreementsHistory.vue?vue&type=template&id=6763234c&scoped=true"
import script from "./AgreementsHistory.vue?vue&type=script&lang=js"
export * from "./AgreementsHistory.vue?vue&type=script&lang=js"
import style0 from "./AgreementsHistory.vue?vue&type=style&index=0&id=6763234c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6763234c",
  null
  
)

export default component.exports